goog.provide("shadow.js.shim.module$date_fns$locale$uk$default");
shadow.js.shim.module$date_fns$locale$uk$default = esm_import$date_fns$locale$uk.default;
